import dayjs from 'dayjs';
import { pluralize } from '@modules/settings/subscription/utils/utils';

//Function to calculate the difference between future date and the current time based on timezone
export function formatFutureTime(
  targetTime: string | Date,
  timezoneDate: string
): { time: string; label: string } | null {
  const now = dayjs(timezoneDate);
  const target = dayjs(targetTime);

  if (!target.isAfter(now)) return null;

  const diffMinutes = target.diff(now, 'minute');
  const diffHours = target.diff(now, 'hour');
  const diffDays = target.diff(now, 'day');
  const diffWeeks = target.diff(now, 'week');
  const diffMonths = target.diff(now, 'month');

  // TODAY
  if (target.isSame(now, 'day')) {
    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;

    if (hours === 0) {
      return { time: pluralize(minutes, 'minute'), label: 'Today' };
    }

    if (minutes === 0) {
      return { time: pluralize(hours, 'hour'), label: 'Today' };
    }

    return {
      time: `${pluralize(hours, 'hour')} ${pluralize(minutes, 'minute')}`,
      label: 'Today',
    };
  }

  // Tomorrow
  if (target.isSame(now.add(1, 'day'), 'day')) {
    const hours = Math.max(diffHours, 1);

    return {
      time: `Tomorrow in ${pluralize(hours, 'hour')}`,
      label: 'Tomorrow',
    };
  }

  // Less than 7 days
  if (diffDays < 7) {
    return {
      time: pluralize(diffDays, 'day'),
      label: `${diffDays} days`,
    };
  }

  // more than four weeks
  if (diffWeeks < 4) {
    return {
      time: pluralize(diffWeeks, 'week'),
      label: pluralize(diffWeeks, 'week'),
    };
  }

  //months
  return {
    time: pluralize(diffMonths, 'month'),
    label: pluralize(diffMonths, 'month'),
  };
}
